export enum MainChipHeaderValues {
    ModelNonTrend = 1,
    ModelTrend = 2,
    GraphColumn = 3,
    GraphDonut = 4,
    GraphHeatMap = 5,
    GraphLine = 6,
}
export enum SubChipHeaderValuesModelNonTrend {
    Funnel = 1,
    NegativeBinomial = 2,
    Poisson = 3,
    TRIOps = 4,
    TRIOpsDate = 5,
}
export enum SubChipHeaderValuesModelTrend {
    FunnelTrend = 1,
    PoissonTrend = 2,
    TRIOpsTrend = 3,
    ProportionsOT = 4,
    EventRatesOT = 5,
}
export enum SubChipHeaderValuesGraphColumn {
    Standard = 1,
    Range = 2,
    Stacked = 3,
}
export enum SubChipHeaderValuesGraphLine {
    SiteStandard = 1,
    SiteAverage = 2,
    SiteCumulative = 3,
    Event = 4,
    SubjectStandard = 5,
    SubjectVisit = 6,
}
